module.exports = __webpack_public_path__ + "static/img/123.5336107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/123.jpg
// module id = BIZL
// module chunks = 1